import React from 'react'
import cx from 'classnames'
import styles from './EmptyState.m.sass'

interface EmptyStateProps {
  children?: React.ReactNode
  className?: string
  title?: string
  subtitle?: React.ReactNode
  image?: React.ReactNode
  small?: boolean
  animate?: boolean
  pad?: boolean
  hideIllustration?: boolean
}

export const EmptyState = ({
  className,
  title = 'Nothing to display.',
  subtitle,
  image,
  small,
  children,
  pad,
  animate = true,
  hideIllustration = false,
}: EmptyStateProps) => (
  <div className={styles.root}>
    <div
      className={cx(
        styles.inner,
        className,
        small && styles.small,
        animate && styles.animate,
        pad && styles.pad
      )}
    >
      {!hideIllustration && image && (
        <div className={styles.imageContainer}>{image}</div>
      )}
      <div className={styles.text}>
        <h3 className={styles.title}>{title}</h3>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      {children && <div className={styles.content}>{children}</div>}
    </div>
  </div>
)

interface EmptyStateIllustrationImageProps {
  src: string
  alt?: string
  title?: string
}

export const EmptyStateIllustrationImage = ({
  src,
  alt,
  title,
}: EmptyStateIllustrationImageProps) => (
  <img className={styles.image} src={src} alt={alt} title={title} />
)

interface EmptyStateFlexProps {
  children?: React.ReactNode
}

export const EmptyStateFlex = ({ children }: EmptyStateFlexProps) => (
  <div className={styles.flex}>{children}</div>
)
